export enum EFontSize {
    SMALL = 'small',
    LARGE = 'large',
    MIDDLE = 'medium'
}